import React from "react";
import { CtaForm } from "../components/CtaForm";

export default function Contact() {
  return (
    <>
      <section className="pagehead">
        <div className="container">
          <div className="pagehead-inner">
            <div>
              <div className="section-label"><span className="dot" />Contact</div>
              <h1 className="pagehead-title display" data-testid="contact-h1">
                Book a <em>30-min walkthrough</em>, or send us a brief.
              </h1>
            </div>
            <p className="pagehead-lede">
              Send us a short brief and we'll reply within a business day — or skip the back-and-forth and pick a slot on our calendar.
            </p>
          </div>
        </div>
      </section>
      <CtaForm />
    </>
  );
}
